import axios from "axios";

const prepareData = (data) => {return {project_qa_welding_inspections_welding_stage:data}}

// Plural Actions
export const GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGES = "get_project_qa_welding_inspections_welding_stages";
export const getProjectQaWeldingInspectionsWeldingStages = () => {
	const url = `/project/qa/welding_inspections/welding_stages.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGES,
		payload: request
	};
};


// Singular Actions
export const CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGE = "create_project_qa_welding_inspections_welding_stage";
export const createProjectQaWeldingInspectionsWeldingStage = (data) => {
	const url = `/project/qa/welding_inspections/welding_stages.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGE,
		payload: request
	};
};

export const GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGE = "get_project_qa_welding_inspections_welding_stage";
export const getProjectQaWeldingInspectionsWeldingStage = (id) => {
	const url = `/project/qa/welding_inspections/welding_stages/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGE,
		payload: request
	};
};

export const UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGE = "update_project_qa_welding_inspections_welding_stage";
export const updateProjectQaWeldingInspectionsWeldingStage = (id,data) => {
	const url = `/project/qa/welding_inspections/welding_stages/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGE,
		payload: request
	};
};

export const DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGE = "destroy_project_qa_welding_inspections_welding_stage";
export const destroyProjectQaWeldingInspectionsWeldingStage = (id) => {
	const url = `/project/qa/welding_inspections/welding_stages/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_STAGE,
		payload: request
	};
};
